import type { IAlertUtilProps } from "@components/organisms/alert/types";
import { IAlertAlignmentEnum } from "@components/organisms/alert/types";
import { useAlertStore } from "@components/organisms/alert/alertStore";
import type { IShowImageViewerProps } from "@components/modals/imageViewer";
import { ImageViewer } from "@components/modals/imageViewer";
import type { IShowVideoViewerProps } from "@components/modals/videoViewer";
import { VideoViewer } from "@components/modals/videoViewer";

const alertStore = useAlertStore.getState();

export const showAlert = (props: IAlertUtilProps) => {
  alertStore.setAlertProps({
    ...props,
    open: true,
    onClose: () => {
      closeAlert();
      props?.onClose?.();
    },
    cancelButtonProps: props.cancelButtonProps
      ? {
          ...props.cancelButtonProps,
          onClick: async (event) => {
            try {
              await props?.cancelButtonProps?.onClick?.(event);
              closeAlert();
            } catch {
              return false;
            }
          },
        }
      : undefined,
    submitButtonProps: props.submitButtonProps
      ? {
          ...props.submitButtonProps,
          onClick: async (event) => {
            try {
              await props?.submitButtonProps?.onClick?.(event);
              closeAlert();
            } catch {
              return false;
            }
          },
        }
      : undefined,
  });
};

export const closeAlert = () => {
  alertStore.reset();
};

export const showImageViewer = (alertProps: IShowImageViewerProps) => {
  showAlert({
    customIcon: alertProps?.icon
      ? { name: alertProps?.icon }
      : { name: "GalleryFill" },
    title: alertProps?.title,
    children: <ImageViewer src={alertProps?.src} title={alertProps?.title} />,
    description: alertProps?.date,
    alignment: IAlertAlignmentEnum.Vertical,
    noMaxWidth: true,
  });
};

export const showVideoViewer = (alertProps: IShowVideoViewerProps) => {
  showAlert({
    customIcon: alertProps?.icon
      ? { name: alertProps?.icon }
      : { name: "VideoFill" },
    title: alertProps?.title,
    children: <VideoViewer src={alertProps?.src} title={alertProps?.title} />,
    description: alertProps?.date,
    alignment: IAlertAlignmentEnum.Vertical,
    noMaxWidth: true,
  });
};
